export function trivialError(message){
  const error = new Error(message);
  handleError(error);
  return Promise.reject(error);
}

export function handleError(error){
  alert(error);
  console.log(error);
}


// WEBPACK FOOTER //
// ./src/utilities.js